import { get, writable } from "svelte/store"
import { config } from "./ConfigStore"


const createOverlayStore = () => {
	const { subscribe, set, update } = writable( { visible: false, context: null } )

	const findContext = id => {
		const found = get( config ).contexts.find( item => item.id === id )
		return { ...found }
	}

	const show = contextId =>
		update( s => {
			const context = findContext( contextId )
			s.context = context
			s.visible = true
			return s
		} )

	const hide = () =>
		update( s => {
			s.visible = false
			// nulling the context variable will remove elements from the dom
			// when the overlay is hidden, so, don't do it
			// s.context = null
			return s
		} )

	return {
		subscribe,
		set,
		update,
		show,
		hide,

	}
}

export const overlay = createOverlayStore()
